/**
 * 챗봇 대화창 헤더의 3점 메뉴.
 *
 * - 새 대화 시작 (resetSession)
 * - 챗봇 숨기기 (영구 숨김, FAB 까지)
 */
import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { confirm as confirmDialog } from "../../util/confirmDialog";

export default function ChatbotMenu({ onReset, onHide }) {
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);

    return (
        <>
            <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)}>
                <MoreVertRoundedIcon sx={{ fontSize: 18, color: "#fff" }} />
            </IconButton>
            <Menu
                anchorEl={anchor}
                open={open}
                onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MenuItem onClick={async () => {
                    setAnchor(null);
                    const ok = await confirmDialog({
                        title: "새 대화 시작",
                        message: "이전 대화 컨텍스트를 초기화합니다. 옛 대화는 위로 스크롤하면 볼 수 있습니다.\n계속할까요?",
                    });
                    if (ok) onReset?.();
                }}>
                    <ListItemIcon><RefreshRoundedIcon fontSize="small" /></ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontSize: 13 }}>새 대화 시작</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => {
                    setAnchor(null);
                    onHide?.();
                }}>
                    <ListItemIcon><VisibilityOffRoundedIcon fontSize="small" /></ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontSize: 13 }}>챗봇 숨기기</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}
